import { BreadCrumbs } from "@stenajs-webui/elements";
import * as React from "react";
import { routeFactory } from "@/RouteFactory";
import { Crumb } from "@/components/bread-crumbs/Crumb";
import { PageHeader } from "@/components/page-header/PageHeader";
import { ExpectedVolumeCustomer } from "../types";
import { ReactNode } from "react";

interface Props {
  customerId: string;
  loading: boolean;
  customer?: ExpectedVolumeCustomer;
  contentRight: ReactNode;
  contentUnder: ReactNode;
}

export const ExpectedVolumeHeader: React.FC<Props> = ({
  customerId,
  customer,
  loading,
  contentRight,
  contentUnder,
}) => {
  return (
    <PageHeader
      title={"Expected volume"}
      loading={loading}
      contentRight={contentRight}
      contentUnder={contentUnder}
      breadcrumbs={
        <BreadCrumbs>
          <Crumb
            label={customer?.breadCrumbName ?? ""}
            path={routeFactory.productAndPrice.customer.customer({
              customerId,
            })}
          />
          <Crumb label={"Expected volumes"} />
        </BreadCrumbs>
      }
    />
  );
};
